import styled from 'styled-components';
import { TOP_HEADER_HEIGHT } from 'modules/constants';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
export const NavigationBar = styled.div `
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: ${theme.spacing.lg} 0;
  background-color: ${theme.semantic.surface.primary};
  width: 100%;
  height: ${pxToRem(TOP_HEADER_HEIGHT)};
  position: sticky;
  top: 0;
  z-index: 1;
`;
